import { c as _c } from "react/compiler-runtime";
import './MissionUserList.scss';
type List = {
  userNick: string;
  thumbUrl: string;
};
interface Props {
  nameList: List[];
}
function MissionUserList(props) {
  const $ = _c(4);
  const {
    nameList
  } = props;
  let t0;
  if ($[0] !== nameList) {
    t0 = nameList.map(_temp);
    $[0] = nameList;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <ul className="mission-user-item-list">{t0}</ul>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(item, index) {
  return <li key={index}><div className="photo"><span className="noImg_colr3">{item.thumbUrl ? <img src={item.thumbUrl} alt="profile" /> : item.userNick.split("")[0]}</span></div></li>;
}
export default MissionUserList;